import { ApiTypes } from "types"
import ProductType from "types/enums/ProductType"

export const SERIALIZED_PRODUCT_TYPES: ReadonlySet<ApiTypes.Model.OrderProductType> = new Set([
  ProductType.Thermostat,
  ProductType.ThermostatV2,
])

export const NON_SERIALIZED_PRODUCT_TYPES: ReadonlySet<ApiTypes.Model.OrderProductType> = new Set([
  ProductType.CWA,
  ProductType.THS,
  ProductType.WLS,
])

export const isSerializedProductType = (productType?: ApiTypes.Model.OrderProductType): boolean =>
  !!productType && SERIALIZED_PRODUCT_TYPES.has(productType)

export const getThermostatVersionFromSn = (sn: string): number | null => {
  const prefix = Number(sn.trim().slice(0, 2))
  if (!Number.isInteger(prefix)) return null
  if (prefix < 20) return 1
  if (prefix <= 29) return 2
  return null
}

const THERMOSTAT_ORDER_VERSION: Partial<Record<ProductType, number>> = {
  [ProductType.Thermostat]: 1,
  [ProductType.ThermostatV2]: 2,
}

export const getThermostatSnMismatchError = (
  sn: string,
  productType?: ApiTypes.Model.OrderProductType,
): string | null => {
  const orderVersion = productType ? THERMOSTAT_ORDER_VERSION[productType] : undefined
  if (orderVersion === undefined) return null

  const snVersion = getThermostatVersionFromSn(sn)
  if (snVersion === null) return "No such thermostat exists"
  if (snVersion === orderVersion) return null

  return `Nuve V${snVersion} thermostats can't be packed into a Nuve V${orderVersion} order`
}
